import { render } from "./Watchlist.vue?vue&type=template&id=6cf7d85c&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"

import "./Watchlist.vue?vue&type=style&index=0&id=6cf7d85c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf7d85c"]])

export default __exports__